<template>
  <div :class="windowWidth ? 'mainSideBarDiv' : 'mainSideBarMobile'">
    <v-navigation-drawer
      v-if="windowWidth"
      :width="!mini ? '800' : '69'"
      permanent
      class="white-sidebar"
    >
      <div>
        <div class="mt-3 mb-0 pb-0">
          <svg
            @click="$router.push('/marketplace/home')"
            width="220"
            class="pointer ml-4"
            height="40"
            viewBox="0 0 324 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect y="3" width="266" height="35" rx="8" fill="#4072B7" />
            <path
              d="M91.512 26V13.31H93.15L98.046 24.344H97.506L102.402 13.31H104.022V26H102.33V15.848H102.924L98.352 26H97.182L92.61 15.848H93.222V26H91.512ZM110.563 26.162C109.759 26.162 109.057 25.976 108.457 25.604C107.857 25.232 107.389 24.692 107.053 23.984C106.729 23.276 106.567 22.436 106.567 21.464C106.567 20.48 106.729 19.64 107.053 18.944C107.389 18.248 107.857 17.714 108.457 17.342C109.057 16.958 109.759 16.766 110.563 16.766C111.355 16.766 112.045 16.964 112.633 17.36C113.221 17.756 113.611 18.296 113.803 18.98H113.605L113.785 16.928H115.549C115.513 17.3 115.477 17.672 115.441 18.044C115.417 18.404 115.405 18.758 115.405 19.106V26H113.587V23.984H113.785C113.593 24.656 113.197 25.19 112.597 25.586C112.009 25.97 111.331 26.162 110.563 26.162ZM111.013 24.74C111.793 24.74 112.417 24.464 112.885 23.912C113.365 23.36 113.605 22.544 113.605 21.464C113.605 20.384 113.365 19.574 112.885 19.034C112.417 18.482 111.793 18.206 111.013 18.206C110.221 18.206 109.585 18.482 109.105 19.034C108.637 19.574 108.403 20.384 108.403 21.464C108.403 22.544 108.637 23.36 109.105 23.912C109.573 24.464 110.209 24.74 111.013 24.74ZM118.221 26V19.178C118.221 18.806 118.209 18.434 118.185 18.062C118.173 17.678 118.149 17.3 118.113 16.928H119.877L120.075 19.268H119.787C119.907 18.704 120.111 18.236 120.399 17.864C120.687 17.492 121.035 17.216 121.443 17.036C121.863 16.856 122.301 16.766 122.757 16.766C122.949 16.766 123.111 16.778 123.243 16.802C123.375 16.814 123.507 16.838 123.639 16.874L123.621 18.494C123.417 18.41 123.237 18.362 123.081 18.35C122.937 18.326 122.757 18.314 122.541 18.314C122.013 18.314 121.563 18.434 121.191 18.674C120.819 18.902 120.537 19.214 120.345 19.61C120.153 20.006 120.057 20.432 120.057 20.888V26H118.221ZM125.243 26V12.752H127.061V20.888H127.097L131.057 16.928H133.307L128.519 21.698L128.537 20.888L133.703 26H131.399L127.097 21.842H127.061V26H125.243ZM139.023 26.162C137.559 26.162 136.407 25.748 135.567 24.92C134.727 24.092 134.307 22.946 134.307 21.482C134.307 20.534 134.487 19.706 134.847 18.998C135.219 18.29 135.729 17.744 136.377 17.36C137.037 16.964 137.799 16.766 138.663 16.766C139.515 16.766 140.229 16.946 140.805 17.306C141.381 17.666 141.819 18.176 142.119 18.836C142.419 19.484 142.569 20.252 142.569 21.14V21.716H135.729V20.672H141.327L141.021 20.906C141.021 20.006 140.817 19.31 140.409 18.818C140.013 18.314 139.437 18.062 138.681 18.062C137.841 18.062 137.193 18.356 136.737 18.944C136.281 19.52 136.053 20.318 136.053 21.338V21.518C136.053 22.586 136.311 23.39 136.827 23.93C137.355 24.47 138.099 24.74 139.059 24.74C139.587 24.74 140.079 24.668 140.535 24.524C141.003 24.368 141.447 24.116 141.867 23.768L142.461 25.01C142.041 25.382 141.531 25.67 140.931 25.874C140.331 26.066 139.695 26.162 139.023 26.162ZM148.366 26.162C147.382 26.162 146.638 25.898 146.134 25.37C145.63 24.83 145.378 24.026 145.378 22.958V18.332H143.614V16.928H145.378V14.534L147.196 14.048V16.928H149.716V18.332H147.196V22.796C147.196 23.468 147.316 23.948 147.556 24.236C147.796 24.524 148.144 24.668 148.6 24.668C148.828 24.668 149.026 24.65 149.194 24.614C149.374 24.566 149.536 24.512 149.68 24.452V25.928C149.5 26 149.29 26.054 149.05 26.09C148.81 26.138 148.582 26.162 148.366 26.162ZM151.577 29.888V19.106C151.577 18.758 151.559 18.404 151.523 18.044C151.499 17.672 151.469 17.3 151.433 16.928H153.197L153.377 18.98H153.179C153.371 18.296 153.755 17.756 154.331 17.36C154.919 16.964 155.615 16.766 156.419 16.766C157.223 16.766 157.925 16.958 158.525 17.342C159.125 17.714 159.587 18.248 159.911 18.944C160.247 19.64 160.415 20.48 160.415 21.464C160.415 22.436 160.247 23.276 159.911 23.984C159.587 24.692 159.125 25.232 158.525 25.604C157.925 25.976 157.223 26.162 156.419 26.162C155.627 26.162 154.937 25.97 154.349 25.586C153.773 25.19 153.389 24.656 153.197 23.984H153.395V29.888H151.577ZM155.969 24.74C156.761 24.74 157.391 24.464 157.859 23.912C158.339 23.36 158.579 22.544 158.579 21.464C158.579 20.384 158.339 19.574 157.859 19.034C157.391 18.482 156.761 18.206 155.969 18.206C155.177 18.206 154.541 18.482 154.061 19.034C153.593 19.574 153.359 20.384 153.359 21.464C153.359 22.544 153.593 23.36 154.061 23.912C154.541 24.464 155.177 24.74 155.969 24.74ZM162.746 26V12.752H164.564V26H162.746ZM170.902 26.162C170.098 26.162 169.396 25.976 168.796 25.604C168.196 25.232 167.728 24.692 167.392 23.984C167.068 23.276 166.906 22.436 166.906 21.464C166.906 20.48 167.068 19.64 167.392 18.944C167.728 18.248 168.196 17.714 168.796 17.342C169.396 16.958 170.098 16.766 170.902 16.766C171.694 16.766 172.384 16.964 172.972 17.36C173.56 17.756 173.95 18.296 174.142 18.98H173.944L174.124 16.928H175.888C175.852 17.3 175.816 17.672 175.78 18.044C175.756 18.404 175.744 18.758 175.744 19.106V26H173.926V23.984H174.124C173.932 24.656 173.536 25.19 172.936 25.586C172.348 25.97 171.67 26.162 170.902 26.162ZM171.352 24.74C172.132 24.74 172.756 24.464 173.224 23.912C173.704 23.36 173.944 22.544 173.944 21.464C173.944 20.384 173.704 19.574 173.224 19.034C172.756 18.482 172.132 18.206 171.352 18.206C170.56 18.206 169.924 18.482 169.444 19.034C168.976 19.574 168.742 20.384 168.742 21.464C168.742 22.544 168.976 23.36 169.444 23.912C169.912 24.464 170.548 24.74 171.352 24.74ZM182.575 26.162C181.663 26.162 180.865 25.976 180.181 25.604C179.509 25.22 178.987 24.674 178.615 23.966C178.255 23.246 178.075 22.394 178.075 21.41C178.075 20.438 178.261 19.604 178.633 18.908C179.005 18.212 179.527 17.684 180.199 17.324C180.871 16.952 181.663 16.766 182.575 16.766C183.163 16.766 183.733 16.868 184.285 17.072C184.837 17.264 185.293 17.54 185.653 17.9L185.059 19.178C184.723 18.854 184.345 18.614 183.925 18.458C183.505 18.29 183.097 18.206 182.701 18.206C181.837 18.206 181.159 18.482 180.667 19.034C180.175 19.586 179.929 20.384 179.929 21.428C179.929 22.484 180.175 23.294 180.667 23.858C181.159 24.422 181.837 24.704 182.701 24.704C183.085 24.704 183.487 24.632 183.907 24.488C184.327 24.332 184.711 24.086 185.059 23.75L185.653 25.028C185.281 25.388 184.813 25.67 184.249 25.874C183.697 26.066 183.139 26.162 182.575 26.162ZM191.797 26.162C190.333 26.162 189.181 25.748 188.341 24.92C187.501 24.092 187.081 22.946 187.081 21.482C187.081 20.534 187.261 19.706 187.621 18.998C187.993 18.29 188.503 17.744 189.151 17.36C189.811 16.964 190.573 16.766 191.437 16.766C192.289 16.766 193.003 16.946 193.579 17.306C194.155 17.666 194.593 18.176 194.893 18.836C195.193 19.484 195.343 20.252 195.343 21.14V21.716H188.503V20.672H194.101L193.795 20.906C193.795 20.006 193.591 19.31 193.183 18.818C192.787 18.314 192.211 18.062 191.455 18.062C190.615 18.062 189.967 18.356 189.511 18.944C189.055 19.52 188.827 20.318 188.827 21.338V21.518C188.827 22.586 189.085 23.39 189.601 23.93C190.129 24.47 190.873 24.74 191.833 24.74C192.361 24.74 192.853 24.668 193.309 24.524C193.777 24.368 194.221 24.116 194.641 23.768L195.235 25.01C194.815 25.382 194.305 25.67 193.705 25.874C193.105 26.066 192.469 26.162 191.797 26.162Z"
              fill="white"
            />
            <path
              d="M78.5325 20.6V27.8C78.5325 28.1183 78.378 28.4235 78.1029 28.6485C77.8279 28.8736 77.4548 29 77.0658 29H60.9325C60.5435 29 60.1705 28.8736 59.8954 28.6485C59.6203 28.4235 59.4658 28.1183 59.4658 27.8V20.6"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M77.9447 11H60.0553C59.8884 11 59.7264 11.0465 59.5962 11.1318C59.4659 11.2172 59.375 11.3363 59.3386 11.4696L58 16.4C58 16.8774 58.2318 17.3352 58.6444 17.6728C59.0569 18.0104 59.6165 18.2 60.2 18.2C60.7835 18.2 61.3431 18.0104 61.7556 17.6728C62.1682 17.3352 62.4 16.8774 62.4 16.4C62.4 16.8774 62.6318 17.3352 63.0444 17.6728C63.4569 18.0104 64.0165 18.2 64.6 18.2C65.1835 18.2 65.7431 18.0104 66.1556 17.6728C66.5682 17.3352 66.8 16.8774 66.8 16.4C66.8 16.8774 67.0318 17.3352 67.4444 17.6728C67.8569 18.0104 68.4165 18.2 69 18.2C69.5835 18.2 70.1431 18.0104 70.5556 17.6728C70.9682 17.3352 71.2 16.8774 71.2 16.4C71.2 16.8774 71.4318 17.3352 71.8444 17.6728C72.2569 18.0104 72.8165 18.2 73.4 18.2C73.9835 18.2 74.5431 18.0104 74.9556 17.6728C75.3682 17.3352 75.6 16.8774 75.6 16.4C75.6 16.8774 75.8318 17.3352 76.2444 17.6728C76.6569 18.0104 77.2165 18.2 77.8 18.2C78.3835 18.2 78.9431 18.0104 79.3556 17.6728C79.7682 17.3352 80 16.8774 80 16.4L78.6604 11.4696C78.6244 11.3363 78.5337 11.2171 78.4036 11.1317C78.2734 11.0463 78.1115 10.9999 77.9447 11Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M59.4658 24.2H71.9325"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M71.9336 29V20.6"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="pt-0 mt-0"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'solutions'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('solutions')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 2.6738L2.2 4.18767V7.7619C2.168 9.11254 3.7336 10.3224 5.1992 11.5642"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.58509 6.78734L6.00029 8.2372C6.08959 8.32888 6.19606 8.40207 6.31364 8.45259C6.43122 8.50311 6.5576 8.52997 6.68556 8.53164C6.81352 8.53331 6.94055 8.50976 7.05941 8.46233C7.17827 8.4149 7.28662 8.34452 7.37829 8.2552C7.46995 8.16589 7.54313 8.05939 7.59364 7.94179C7.64415 7.82419 7.67101 7.69779 7.67268 7.56981C7.67435 7.44182 7.6508 7.31477 7.60338 7.19589C7.55596 7.07701 7.48558 6.96863 7.39629 6.87696L5.19549 4.63096V3.46035C5.07625 2.7589 4.80958 2.09074 4.41309 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.2002 7.41145V17.1028C5.2002 17.4211 5.32662 17.7264 5.55167 17.9515C5.77671 18.1765 6.08194 18.303 6.4002 18.303H12.4002"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 18.3286L17.7996 16.8147V13.2413C17.8276 12.0739 16.6628 11.0121 15.3996 9.94472V14.1999L13.9996 12.766C13.8193 12.5809 13.5728 12.4749 13.3144 12.4716C13.0559 12.4682 12.8067 12.5676 12.6216 12.748C12.4365 12.9284 12.3306 13.1749 12.3272 13.4334C12.3239 13.6919 12.4233 13.9411 12.6036 14.1263L14.8076 16.3731V17.5429C14.9275 18.2432 15.1941 18.9101 15.59 19.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.782 15.3025H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.79961 12.3019H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.6004 5.10064C16.6004 5.81278 16.3893 6.50893 15.9937 7.10105C15.5981 7.69317 15.0359 8.15467 14.3781 8.4272C13.7202 8.69972 12.9964 8.77103 12.2981 8.6321C11.5997 8.49316 10.9583 8.15024 10.4548 7.64668C9.95134 7.14312 9.60847 6.50155 9.46957 5.80309C9.33066 5.10463 9.40195 4.38067 9.67443 3.72273C9.9469 3.0648 10.4083 2.50246 11.0003 2.10682C11.5924 1.71117 12.2884 1.5 13.0004 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.5996 2.39938L13.3196 5.67997C13.2777 5.72216 13.2278 5.75564 13.1729 5.77849C13.118 5.80134 13.0591 5.8131 12.9996 5.8131C12.9402 5.8131 12.8813 5.80134 12.8263 5.77849C12.7714 5.75564 12.7216 5.72216 12.6796 5.67997L11.6484 4.64778"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Solutions
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'vendors' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('vendors')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7824H5.30375L8.11175 18.1551C8.21361 18.3458 8.33692 18.4996 8.47436 18.6073C8.61179 18.7151 8.76054 18.7746 8.91175 18.7824C10.5465 16.7768 12.0823 14.5466 13.5037 12.1142C13.5917 11.6915 13.4238 11.2688 13.2718 10.9143L11.2637 6.49609"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41846H2.6C2.80154 2.41736 2.99589 2.54596 3.14421 2.77855C3.29253 3.01114 3.38388 3.33058 3.4 3.673V12.4275C3.38198 12.7675 3.2898 13.0836 3.14168 13.3133C2.99356 13.5431 2.80027 13.6698 2.6 13.6684H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6684H17.3996C17.1993 13.6698 17.0061 13.5431 16.8579 13.3133C16.7098 13.0836 16.6176 12.7675 16.5996 12.4275V3.673C16.6157 3.33058 16.7071 3.01114 16.8554 2.77855C17.0037 2.54596 17.1981 2.41736 17.3996 2.41846H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Vendors
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'providers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('providers')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1  mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2002 11.8C15.6217 12.3923 16.836 13.392 17.6902 14.6733C18.5444 15.9546 19.0002 17.4601 19.0002 19"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.40039 18.9999C3.40331 17.953 3.61736 16.9175 4.02974 15.9553C4.44211 14.9931 5.04434 14.124 5.80039 13.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.2002 10.6V12.4C14.2002 13.1956 13.8841 13.9587 13.3215 14.5213C12.7589 15.0839 11.9958 15.4 11.2002 15.4C10.4045 15.4 9.64148 15.0839 9.07887 14.5213C8.51627 13.9587 8.2002 13.1956 8.2002 12.4V10.6"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.6 9.80009C3.48366 9.80009 4.2 9.08374 4.2 8.20009C4.2 7.31643 3.48366 6.60009 2.6 6.60009C1.71634 6.60009 1 7.31643 1 8.20009C1 9.08374 1.71634 9.80009 2.6 9.80009Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.19238 8.33593C4.66051 8.50144 5.06578 8.80806 5.35234 9.21354C5.6389 9.61903 5.79264 10.1034 5.79238 10.5999V17.1999C5.79238 17.437 5.8392 17.6717 5.93016 17.8906C6.02112 18.1095 6.15442 18.3083 6.32242 18.4755C6.49041 18.6428 6.68979 18.7752 6.9091 18.8652C7.12841 18.9552 7.36333 19.001 7.60038 18.9999H9.40038C9.87777 18.9999 10.3356 18.8103 10.6732 18.4727C11.0107 18.1351 11.2004 17.6773 11.2004 17.1999V15.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.2 9.39999C13.5196 9.39999 15.4 7.51959 15.4 5.2C15.4 2.8804 13.5196 1 11.2 1C8.8804 1 7 2.8804 7 5.2C7 7.51959 8.8804 9.39999 11.2 9.39999Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59961 3.06396C8.24732 3.73694 9.02373 4.27283 9.88267 4.63977C10.7416 5.00671 11.6656 5.19722 12.5996 5.19996C13.5489 5.20262 14.4885 5.00925 15.3596 4.63196"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Providers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'invoices'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('invoices')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 2.6738L2.2 4.18767V7.7619C2.168 9.11254 3.7336 10.3224 5.1992 11.5642"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.58509 6.78734L6.00029 8.2372C6.08959 8.32888 6.19606 8.40207 6.31364 8.45259C6.43122 8.50311 6.5576 8.52997 6.68556 8.53164C6.81352 8.53331 6.94055 8.50976 7.05941 8.46233C7.17827 8.4149 7.28662 8.34452 7.37829 8.2552C7.46995 8.16589 7.54313 8.05939 7.59364 7.94179C7.64415 7.82419 7.67101 7.69779 7.67268 7.56981C7.67435 7.44182 7.6508 7.31477 7.60338 7.19589C7.55596 7.07701 7.48558 6.96863 7.39629 6.87696L5.19549 4.63096V3.46035C5.07625 2.7589 4.80958 2.09074 4.41309 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.2002 7.41145V17.1028C5.2002 17.4211 5.32662 17.7264 5.55167 17.9515C5.77671 18.1765 6.08194 18.303 6.4002 18.303H12.4002"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 18.3286L17.7996 16.8147V13.2413C17.8276 12.0739 16.6628 11.0121 15.3996 9.94472V14.1999L13.9996 12.766C13.8193 12.5809 13.5728 12.4749 13.3144 12.4716C13.0559 12.4682 12.8067 12.5676 12.6216 12.748C12.4365 12.9284 12.3306 13.1749 12.3272 13.4334C12.3239 13.6919 12.4233 13.9411 12.6036 14.1263L14.8076 16.3731V17.5429C14.9275 18.2432 15.1941 18.9101 15.59 19.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.782 15.3025H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.79961 12.3019H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.6004 5.10064C16.6004 5.81278 16.3893 6.50893 15.9937 7.10105C15.5981 7.69317 15.0359 8.15467 14.3781 8.4272C13.7202 8.69972 12.9964 8.77103 12.2981 8.6321C11.5997 8.49316 10.9583 8.15024 10.4548 7.64668C9.95134 7.14312 9.60847 6.50155 9.46957 5.80309C9.33066 5.10463 9.40195 4.38067 9.67443 3.72273C9.9469 3.0648 10.4083 2.50246 11.0003 2.10682C11.5924 1.71117 12.2884 1.5 13.0004 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.5996 2.39938L13.3196 5.67997C13.2777 5.72216 13.2278 5.75564 13.1729 5.77849C13.118 5.80134 13.0591 5.8131 12.9996 5.8131C12.9402 5.8131 12.8813 5.80134 12.8263 5.77849C12.7714 5.75564 12.7216 5.72216 12.6796 5.67997L11.6484 4.64778"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Invoices
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'account' ||
            watchActiveItem == 'account/contract' ||
            watchActiveItem == 'account/bank' ||
            watchActiveItem == 'account/users' ||
            watchActiveItem == 'account/settings'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
              @click="activeItem('account')"
              class="list-item-icon no-padding"
              :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.84668 3.1472C7.84668 3.71667 8.07356 4.26282 8.47741 4.6655C8.88126 5.06818 9.429 5.2944 10.0001 5.2944C10.5713 5.2944 11.119 5.06818 11.5229 4.6655C11.9267 4.26282 12.1536 3.71667 12.1536 3.1472C12.1536 2.57773 11.9267 2.03158 11.5229 1.6289C11.119 1.22622 10.5713 1 10.0001 1C9.429 1 8.88126 1.22622 8.47741 1.6289C8.07356 2.03158 7.84668 2.57773 7.84668 3.1472V3.1472Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5654 10.5C12.8102 10.4961 13.0523 10.5513 13.2709 10.6611C13.4896 10.7709 13.6782 10.932 13.8208 11.1304C13.9633 11.3288 14.0555 11.5588 14.0893 11.8005C14.1232 12.0423 14.0978 12.2886 14.0152 12.5184"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 5.2944V19"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9746 4H18.3042C20.452 4 17.3414 9.1624 12.8708 7.44"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.0233 4H1.69532C-0.451716 4 2.65812 9.1624 7.1287 7.44"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.4342 10.5C7.03072 10.4959 6.64208 10.6516 6.35347 10.9327C6.06486 11.2139 5.89982 11.5977 5.89453 12C5.89666 12.4099 6.05844 12.8029 6.34572 13.096C6.633 13.3892 7.0233 13.5596 7.4342 13.5712H11.5389C11.9473 13.5712 12.3389 13.7329 12.6276 14.0209C12.9164 14.3088 13.0786 14.6992 13.0786 15.1064C13.0786 15.5136 12.9164 15.904 12.6276 16.192C12.3389 16.4799 11.9473 16.6416 11.5389 16.6416H8.71713C8.36869 16.6496 8.03769 16.7952 7.79695 17.0465C7.55621 17.2978 7.42544 17.6342 7.4334 17.9816C7.43239 18.1681 7.46966 18.3528 7.54293 18.5243C7.6162 18.6959 7.72391 18.8507 7.85944 18.9792"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'account' ||
                watchActiveItem == 'account/contract' ||
                watchActiveItem == 'account/bank' ||
                watchActiveItem == 'account/users' ||
                watchActiveItem == 'account/settings'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('account')"
              class="text-gray-darker"
              >Account
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'account/plan-info'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-1"
              @click="activeItem('account/plan-info')"
            >
              Plan Info
            </div>
            <div
              :class="
                watchActiveItem == 'account/tpa-info'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-3"
              @click="activeItem('account/tpa-info')"
            >
              TPA Info
            </div>
             <div
              :class="
                watchActiveItem == 'account/broker-info'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-3"
              @click="activeItem('account/broker-info')"
            >
              Broker Info
            </div>
            <div
              :class="
                watchActiveItem == 'account/contract'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-3"
              @click="activeItem('account/contract')"
            >
              Contracts
            </div>
      
            <!-- <div
              :class="
                watchActiveItem == 'account/bank'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-3"
              @click="activeItem('account/bank')"
            >
              Bank Info
            </div> -->

            <div
              :class="
                watchActiveItem == 'account/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-3 ml-2"
              @click="activeItem('account/users')"
            >
              Users
            </div>

            <div
              :class="
                watchActiveItem == 'account/settings'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-3 ml-2"
              @click="activeItem('account/settings')"
            >
              Settings
            </div>
          </div>
        </v-list-group>

        <div></div>
      </div>

      <div>
        <v-divider></v-divider>
        <v-list-item two-line v-if="!mini" class="mb-2">
          <span class="orange--text mt-1 ml-1" style="font-size: 9px">
            Powered by:
          </span>

          <v-list-item-content
            class="no-padding pointer justify-center mt-2 mb-2"
          >
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img src="/apalyhealthlogo.png" alt="" class="mt-1 ml-1" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line v-else class="mt-4">
          <v-list-item-content class="no-padding pointer">
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img
                src="/apaly1.png"
                class="ml-1"
                width="95"
                height="45"
                alt=""
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>
    <!-- Mobile -->
    <v-navigation-drawer v-else permanent class="white-sidebar-onmobile mt-3">
      <div class="ml-3">
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="mt-2"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon class="list-item-icon no-padding ml-4 ml-md-1 mt-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'vendors' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('vendors')"
        >
          <v-list-item-icon class="list-item-icon no-padding ml-4 ml-md-1 mt-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7824H5.30375L8.11175 18.1551C8.21361 18.3458 8.33692 18.4996 8.47436 18.6073C8.61179 18.7151 8.76054 18.7746 8.91175 18.7824C10.5465 16.7768 12.0823 14.5466 13.5037 12.1142C13.5917 11.6915 13.4238 11.2688 13.2718 10.9143L11.2637 6.49609"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41846H2.6C2.80154 2.41736 2.99589 2.54596 3.14421 2.77855C3.29253 3.01114 3.38388 3.33058 3.4 3.673V12.4275C3.38198 12.7675 3.2898 13.0836 3.14168 13.3133C2.99356 13.5431 2.80027 13.6698 2.6 13.6684H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6684H17.3996C17.1993 13.6698 17.0061 13.5431 16.8579 13.3133C16.7098 13.0836 16.6176 12.7675 16.5996 12.4275V3.673C16.6157 3.33058 16.7071 3.01114 16.8554 2.77855C17.0037 2.54596 17.1981 2.41736 17.3996 2.41846H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Vendors
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'providers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('providers')"
        >
          <v-list-item-icon class="list-item-icon no-padding ml-4 ml-md-1 mt-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2002 11.8C15.6217 12.3923 16.836 13.392 17.6902 14.6733C18.5444 15.9546 19.0002 17.4601 19.0002 19"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.40039 18.9999C3.40331 17.953 3.61736 16.9175 4.02974 15.9553C4.44211 14.9931 5.04434 14.124 5.80039 13.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.2002 10.6V12.4C14.2002 13.1956 13.8841 13.9587 13.3215 14.5213C12.7589 15.0839 11.9958 15.4 11.2002 15.4C10.4045 15.4 9.64148 15.0839 9.07887 14.5213C8.51627 13.9587 8.2002 13.1956 8.2002 12.4V10.6"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.6 9.80009C3.48366 9.80009 4.2 9.08374 4.2 8.20009C4.2 7.31643 3.48366 6.60009 2.6 6.60009C1.71634 6.60009 1 7.31643 1 8.20009C1 9.08374 1.71634 9.80009 2.6 9.80009Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.19238 8.33593C4.66051 8.50144 5.06578 8.80806 5.35234 9.21354C5.6389 9.61903 5.79264 10.1034 5.79238 10.5999V17.1999C5.79238 17.437 5.8392 17.6717 5.93016 17.8906C6.02112 18.1095 6.15442 18.3083 6.32242 18.4755C6.49041 18.6428 6.68979 18.7752 6.9091 18.8652C7.12841 18.9552 7.36333 19.001 7.60038 18.9999H9.40038C9.87777 18.9999 10.3356 18.8103 10.6732 18.4727C11.0107 18.1351 11.2004 17.6773 11.2004 17.1999V15.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.2 9.39999C13.5196 9.39999 15.4 7.51959 15.4 5.2C15.4 2.8804 13.5196 1 11.2 1C8.8804 1 7 2.8804 7 5.2C7 7.51959 8.8804 9.39999 11.2 9.39999Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59961 3.06396C8.24732 3.73694 9.02373 4.27283 9.88267 4.63977C10.7416 5.00671 11.6656 5.19722 12.5996 5.19996C13.5489 5.20262 14.4885 5.00925 15.3596 4.63196"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Providers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'invoices'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('invoices')"
        >
          <v-list-item-icon class="list-item-icon no-padding ml-4 ml-md-1 mt-3">
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 2.6738L2.2 4.18767V7.7619C2.168 9.11254 3.7336 10.3224 5.1992 11.5642"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.58509 6.78734L6.00029 8.2372C6.08959 8.32888 6.19606 8.40207 6.31364 8.45259C6.43122 8.50311 6.5576 8.52997 6.68556 8.53164C6.81352 8.53331 6.94055 8.50976 7.05941 8.46233C7.17827 8.4149 7.28662 8.34452 7.37829 8.2552C7.46995 8.16589 7.54313 8.05939 7.59364 7.94179C7.64415 7.82419 7.67101 7.69779 7.67268 7.56981C7.67435 7.44182 7.6508 7.31477 7.60338 7.19589C7.55596 7.07701 7.48558 6.96863 7.39629 6.87696L5.19549 4.63096V3.46035C5.07625 2.7589 4.80958 2.09074 4.41309 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.2002 7.41145V17.1028C5.2002 17.4211 5.32662 17.7264 5.55167 17.9515C5.77671 18.1765 6.08194 18.303 6.4002 18.303H12.4002"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 18.3286L17.7996 16.8147V13.2413C17.8276 12.0739 16.6628 11.0121 15.3996 9.94472V14.1999L13.9996 12.766C13.8193 12.5809 13.5728 12.4749 13.3144 12.4716C13.0559 12.4682 12.8067 12.5676 12.6216 12.748C12.4365 12.9284 12.3306 13.1749 12.3272 13.4334C12.3239 13.6919 12.4233 13.9411 12.6036 14.1263L14.8076 16.3731V17.5429C14.9275 18.2432 15.1941 18.9101 15.59 19.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.782 15.3025H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.79961 12.3019H7.59961"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.6004 5.10064C16.6004 5.81278 16.3893 6.50893 15.9937 7.10105C15.5981 7.69317 15.0359 8.15467 14.3781 8.4272C13.7202 8.69972 12.9964 8.77103 12.2981 8.6321C11.5997 8.49316 10.9583 8.15024 10.4548 7.64668C9.95134 7.14312 9.60847 6.50155 9.46957 5.80309C9.33066 5.10463 9.40195 4.38067 9.67443 3.72273C9.9469 3.0648 10.4083 2.50246 11.0003 2.10682C11.5924 1.71117 12.2884 1.5 13.0004 1.5"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.5996 2.39938L13.3196 5.67997C13.2777 5.72216 13.2278 5.75564 13.1729 5.77849C13.118 5.80134 13.0591 5.8131 12.9996 5.8131C12.9402 5.8131 12.8813 5.80134 12.8263 5.77849C12.7714 5.75564 12.7216 5.72216 12.6796 5.67997L11.6484 4.64778"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Invoices
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'account' ||
            watchActiveItem == 'account/contract' ||
            watchActiveItem == 'account/bank' ||
            watchActiveItem == 'account/users' ||
            watchActiveItem == 'account/settings'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
              @click="activeItem('account')"
              class="list-item-icon no-padding ml-4 ml-md-1 mt-3"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.84668 3.1472C7.84668 3.71667 8.07356 4.26282 8.47741 4.6655C8.88126 5.06818 9.429 5.2944 10.0001 5.2944C10.5713 5.2944 11.119 5.06818 11.5229 4.6655C11.9267 4.26282 12.1536 3.71667 12.1536 3.1472C12.1536 2.57773 11.9267 2.03158 11.5229 1.6289C11.119 1.22622 10.5713 1 10.0001 1C9.429 1 8.88126 1.22622 8.47741 1.6289C8.07356 2.03158 7.84668 2.57773 7.84668 3.1472V3.1472Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.5654 10.5C12.8102 10.4961 13.0523 10.5513 13.2709 10.6611C13.4896 10.7709 13.6782 10.932 13.8208 11.1304C13.9633 11.3288 14.0555 11.5588 14.0893 11.8005C14.1232 12.0423 14.0978 12.2886 14.0152 12.5184"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 5.2944V19"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9746 4H18.3042C20.452 4 17.3414 9.1624 12.8708 7.44"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.0233 4H1.69532C-0.451716 4 2.65812 9.1624 7.1287 7.44"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.4342 10.5C7.03072 10.4959 6.64208 10.6516 6.35347 10.9327C6.06486 11.2139 5.89982 11.5977 5.89453 12C5.89666 12.4099 6.05844 12.8029 6.34572 13.096C6.633 13.3892 7.0233 13.5596 7.4342 13.5712H11.5389C11.9473 13.5712 12.3389 13.7329 12.6276 14.0209C12.9164 14.3088 13.0786 14.6992 13.0786 15.1064C13.0786 15.5136 12.9164 15.904 12.6276 16.192C12.3389 16.4799 11.9473 16.6416 11.5389 16.6416H8.71713C8.36869 16.6496 8.03769 16.7952 7.79695 17.0465C7.55621 17.2978 7.42544 17.6342 7.4334 17.9816C7.43239 18.1681 7.46966 18.3528 7.54293 18.5243C7.6162 18.6959 7.72391 18.8507 7.85944 18.9792"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'account' ||
                watchActiveItem == 'account/contract' ||
                watchActiveItem == 'account/bank' ||
                watchActiveItem == 'account/users' ||
                watchActiveItem == 'account/settings'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('account')"
              class="text-gray-darker"
              >Account
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'account/contract'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-1"
              @click="activeItem('account/contract')"
            >
              Contract
            </div>
            <div
              :class="
                watchActiveItem == 'account/bank'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-2 mt-3"
              @click="activeItem('account/bank')"
            >
              Bank Info
            </div>

            <div
              :class="
                watchActiveItem == 'account/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-3 ml-2"
              @click="activeItem('account/users')"
            >
              Users
            </div>

            <div
              :class="
                watchActiveItem == 'account/settings'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-3 ml-2"
              @click="activeItem('account/settings')"
            >
              Settings
            </div>
          </div>
        </v-list-group>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "Tables",
  data() {
    return {
      miniVersion: true,
      item: "home",
      items: [
        {
          icon: "fas fa-home",
          title: "Home",
        },
        {
          icon: "fas fa-users",
          title: "Clients",
        },
        {
          icon: "fas fa-cog",
          title: "Settings",
        },
      ],
      route: this.$route.path,
    };
  },
  props: {
    windowWidth: {
      type: Boolean,
    },
    mini: {
      type: Boolean,
    },
  },

  computed: {
    routeParams() {
      return this.$route.params.name;
    },
    path() {
      return this.$route.path.replace(/%20/g, " ");
    },
    watchActiveItem() {
      if (this.$route.path.includes("/employer-client/account/users")) {
        this.item = "account/users";
      } else if (
        this.$route.path.includes("/employer-client/account/settings")
      ) {
        this.item = "account/settings";
      } else if (
        this.$route.path.includes("/employer-client/account/contract")
      ) {
        this.item = "account/contract";
      }  else if (
        this.$route.path.includes("/employer-client/account/tpa-info")
      ) {
        this.item = "account/tpa-info";
      } else if (
        this.$route.path.includes("/employer-client/account/broker-info")
      ) {
        this.item = "account/broker-info";
      } else if (
        this.$route.path.includes("/employer-client/account/plan-info")
      ) {
        this.item = "account/plan-info";
      }else if (this.$route.path.includes("/employer-client/account/bank")) {
        this.item = "account/bank";
      } else if (this.$route.path.includes(this.$route.path.split("/")[2])) {
        this.item = this.$route.path.split("/")[2];
      }

      return this.item;
    },
  },
  created() {},
  methods: {
    activeItem(tab) {
      if (this.$route.path != `/employer-client/${tab}`) {
        this.$router.push(`/employer-client/${tab}`);
      }
      if (!this.windowWidth) {
        this.$emit("closeSideBar");
      }
    },
  },
};
</script>

